<template>
  <transition v-if="position === 'center'" name="ssui-fade">
    <div class="ssui-dialog-wrapper" @touchmove="onTouchMove" v-show="currentValue">
        <div
          :class="hasMask ? 'ssui-mask' : 'ssui-mask_transparent'"
          @click="maskClose && (currentValue = false)"
        ></div>
        <div class="ssui-dialog-content">
            <slot></slot>
        </div>
    </div>
  </transition>
  <div v-else class="slide-dialog-wrapper">
    <transition name="ssui-fade">
      <div
        v-show="currentValue"
        :class="hasMask ? 'ssui-mask' : 'ssui-mask_transparent'"
        @click="maskClose && (currentValue = false)"
        @touchmove="onTouchMove"
      ></div>
    </transition>
    <transition name="ssui-slide">
      <div v-show="currentValue" class="ssui-slide-content" @touchmove="onTouchMove">
        <slot></slot>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    position: {
      type: String,
      // center、bottom
      default: 'center',
    },
    hasMask: {
      type: Boolean,
      default: true
    },
    maskClose: {
      type: Boolean,
      default: true
    },
    canScroll: {
      type: Boolean,
      default: true
    }
  },
  created () {
    if (typeof this.value !== 'undefined') {
      this.currentValue = this.value
    }
  },
  watch: {
    value: {
      handler: function (val) {
        this.currentValue = val
      },
      immediate: true
    },
    currentValue (val) {
      this.$emit(val ? 'on-show' : 'on-hide')
      this.$emit('input', val)
    }
  },
  data () {
    return {
      currentValue: false
    }
  },
  methods: {
    onTouchMove: function (event) {
      !this.canScroll && event.preventDefault()
    }
  }
}
</script>

<style lang="less">
@import '~@finance/ssui/export/ssui.less';
@import '../../assets/less/transition.less';
// TODO 考虑是否放在ssui中
.ssui-slide-content {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: @dialogContentZIndex;
}
.slide-dialog-wrapper {
  position: fixed;
  z-index: @dialogWrapperZIndex;
}
</style>
